import { useEffect, useState } from "react";
import src from "../../../images/cyber.jpg";

function UpcomingEvent() {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;

  useEffect(() => {
    // 10 days counddown
    const countdownDate = new Date("Jun 6, 2022 00:00:00");

    const id = setInterval(() => {
      const now = new Date().getTime();

      const difference = countdownDate - now;

      const days = Math.floor(difference / day),
        hours = Math.floor((difference % day) / hour),
        minutes = Math.floor((difference % hour) / minute),
        seconds = Math.floor((difference % minute) / second);

      setDays(days);
      setHours(hours);
      setMinutes(minutes);
      setSeconds(seconds);
    }, 1000);

    return () => {
      clearInterval(id);
    };
  }, [day, hour, minute, second]);

  return (
    <section
      className="hero text-center"
      style={{
        backgroundImage: `url(${src})`,
      }}
    >
      <div class="hero-overlay bg-opacity-60"></div>

      <div className="p-8 pb-16 flex flex-col gap-6">
        <h1 className="text-base-300">Upcoming Events</h1>

        <h2 className="text-base-300">GEARS GLOBAL SUMMIT 2022</h2>

        <div class="grid grid-flow-col gap-5 text-center auto-cols-max justify-center">
          <div class="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
            <span class="countdown font-mono text-5xl">
              <span
                style={{
                  "--value": days,
                }}
              ></span>
            </span>
            days
          </div>

          <div class="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
            <span class="countdown font-mono text-5xl">
              <span
                style={{
                  "--value": hours,
                }}
              ></span>
            </span>
            hours
          </div>

          <div class="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
            <span class="countdown font-mono text-5xl">
              <span
                style={{
                  "--value": minutes,
                }}
              ></span>
            </span>
            min
          </div>

          <div class="flex flex-col p-2 bg-neutral rounded-box text-neutral-content">
            <span class="countdown font-mono text-5xl">
              <span
                style={{
                  "--value": seconds,
                }}
              ></span>
            </span>
            sec
          </div>
        </div>
      </div>
    </section>
  );
}

export default UpcomingEvent;
